import { useEffect } from "react";
import { useLocation } from "react-router";
import useAppPersistence from "./persistence/useAppPersistence";

/**
 * Sets current screen user is on relative to the resource + id + search queries (e.g. "?tab=")
 * Necessary for persistence
 */

const useSetCurrentResourceScreen = () => {
  const { pathname, search } = useLocation();
  const { getCurrentResourceScreen, setCurrentResourceScreen } =
    useAppPersistence();

  const currentPage = pathname?.split("/")?.[1];
  const currentResourceScreen = getCurrentResourceScreen(currentPage);

  useEffect(() => {
    const currentResourceURL = `${pathname}${search}`;
    if (currentResourceURL !== currentResourceScreen) {
      setCurrentResourceScreen(currentPage, currentResourceURL);
    }
  }, [
    currentPage,
    pathname,
    search,
    currentResourceScreen,
    setCurrentResourceScreen,
  ]);
};

export default useSetCurrentResourceScreen;
